module.exports = __webpack_public_path__ + "img/vertical_card.edb84ed4.jpg";